import styled from '@nfinite/react-hubstairs/styled'
import OrganizationDemoBadge from 'components/Commons/OrganizationDemoBadge'

export const LogoMainWrapper = styled('div')`
  position: relative;
`

export const OrganizationLogoWrapper = function ({ className, organization = {}, children, dataTestId }) {
  const { forInternalTesting } = organization
  return (
    <LogoMainWrapper className={className} data-testid={dataTestId}>
      <OrganizationDemoBadge forInternalTesting={forInternalTesting} />
      {children}
    </LogoMainWrapper>
  )
}
